import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchCourse, fetchCourseCreate, editCourse,
} from "Actions/Admin/Course/CourseActions";



/**
 * The Course Edit Dialog
 */
class CourseEdit extends React.Component {
    // The Initial Data
    initialData = {
        courseID            : 0,
        name                : "",
        url                 : "",
        correlativeCourse   : 0,
        filterInInscription : 1,
        requiredToBeCoach   : 0,
        completeToCoach     : 0,
        position            : 0,
        status              : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, position, fetchCourse, fetchCourseCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchCourse(elemID);
                loading = true;
            // Load edit data
            } else {
                fetchCourseCreate();
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editCourse(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, courses } = this.props;
        const { data, loading, errors          } = this.state;

        return <EditDialog
            open={open}
            icon="course"
            title={!!elemID ? "COURSES_EDIT_TITLE" : "COURSES_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="COURSES_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                name="url"
                label="COURSES_ITS_URL"
                helperText="COURSES_URL_HELP"
                value={data.url}
                error={errors.url}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="correlativeCourse"
                label="COURSES_CORRELATIVE"
                value={data.correlativeCourse}
                error={errors.correlativeCourse}
                onChange={this.handleChange}
                options={courses}
                withNone
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />

                <InputField
                    type="toggle"
                    name="filterInInscription"
                    label="COURSES_FILTER_IN_INSCRIPTION"
                    value={data.filterInInscription}
                    onChange={this.handleChange}
                />
                <InputField
                    type="toggle"
                    name="requiredToBeCoach"
                    label="COURSES_REQUIRED_TO_BE_COACH"
                    value={data.requiredToBeCoach}
                    onChange={this.handleChange}
                />
                <InputField
                    type="toggle"
                    name="completeToCoach"
                    label="COURSES_COMPLETE_TO_COACH"
                    value={data.completeToCoach}
                    onChange={this.handleChange}
                />
            </Columns>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchCourse       : PropTypes.func.isRequired,
        fetchCourseCreate : PropTypes.func.isRequired,
        editCourse        : PropTypes.func.isRequired,
        open              : PropTypes.bool.isRequired,
        onClose           : PropTypes.func.isRequired,
        onSubmit          : PropTypes.func.isRequired,
        edition           : PropTypes.number.isRequired,
        position          : PropTypes.number.isRequired,
        courses           : PropTypes.array.isRequired,
        elem              : PropTypes.object.isRequired,
        elemID            : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.course.edition,
            position : state.course.position,
            courses  : state.course.courses,
            elem     : state.course.elem,
        };
    }
}

export default connect(CourseEdit.mapStateToProps, {
    fetchCourse, fetchCourseCreate, editCourse,
})(CourseEdit);
